import { generateUsernames } from '../../shared/usernameFormats'

const COLORS = [
  '#c45d3e', '#b8952a', '#4a8c5c', '#4a6fa5', '#8c5a8c',
  '#5a8c8c', '#8c6d4a', '#6b5d8c', '#8c4a5a', '#3e8c7a',
];

export function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

export function initials(first, last) {
  return (first?.[0] || '').toUpperCase() + (last?.[0] || '').toUpperCase();
}

export function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('de-DE', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

export { generateUsernames };

export const STATUSES = [
  { key: 'neu', label: 'Neu' },
  { key: 'gesucht', label: 'Gesucht' },
  { key: 'gefunden', label: 'Gefunden' },
  { key: 'kontaktiert', label: 'Kontaktiert' },
  { key: 'zugesagt', label: 'Zugesagt' },
  { key: 'abgesagt', label: 'Abgesagt' },
];
